import { Flex, Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react'

import { useTranslation } from '~/lib/i18n'
import { theme } from '~/styles/theme'
import { LensMarket } from '~/types'
import Card from './Card'
import TokenBalanceRow from './TokenBalanceRow'

interface Props {
  markets: LensMarket[]
}

const TokenBalancesTable = ({ markets }: Props) => {
  const { t } = useTranslation('faucet')

  return (
    <Card>
      <Flex
        maxW="600px"
        direction="column"
        background={theme.colors.background.box}
        border="1px solid #FFFFFF12"
        borderRadius="2xl"
        mb={5}
      >
        <TableContainer>
          <Table mt={0} variant="unstyled">
            <Thead>
              <Tr color="text.secondary" borderBottom="1px solid #FFFFFF12">
                <Th textTransform="none">{t('table.token')}</Th>
                <Th textTransform="none" textAlign="right">
                  {t('table.balance')}
                </Th>
                <Th textTransform="none" textAlign="right" display={{ base: 'none', md: 'table-cell' }}>
                  {t('table.value')}
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {markets.map((market: LensMarket) => (
                <TokenBalanceRow key={market.underlyingToken} market={market} />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Flex>
    </Card>
  )
}

export default TokenBalancesTable
